import React from 'react';
import {sortBy} from "lodash";
import formatters from "../../../utils/forms/formatters";
import LineChart from '../../theme/charts/LineChart'

export class NoteSection extends React.Component {

    static defaultProps = {
        notes: [],
        isOpenOnMount: true
    }

    constructor(props) {
        super(props);
        this.state = {
            open: this.props.isOpenOnMount
        }
    }

    render() {
        let notes = this.props.notes || [];
        notes = sortBy(notes, note => note.title)
        
        let rows =  notes.map(note => {
            return (
                <tr key={note.title}>
                    <td className="is-size-7 has-text-weight-semibold">
                        {note.title}
                    </td>
                    <td className="has-text-grey is-size-7">
                        {note.note}
                    </td>
                </tr>
            )
        })

        return (
            <div className="card-notes" className={this.props.notes.length >= 1 ? 'print' : 'no-print'}>
                {this.props.title &&
                    <div className="is-flex justify-space-between is-align-items-center has-icons-and-text-aligned"
                         onClick={() => {this.setState({open: !this.state.open})}}
                     >
                    <p className={`is-size-5 mt-4 mb-2 ${this.state.open ? '' : 'has-text-grey'}`}>{this.props.title}</p>
                    <i className={`fa ${this.state.open ? 'fa-caret-down' : 'fa-caret-left has-text-grey'} mt-2 is-size-5`} />

                </div>

                }
                <div className="table-container mb-5 printable-notes-open" style={this.state.open ? {height: "unset"} : {height: 0} }>
                    <table className="table">
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}


export default class loanEstimateCardPrintable extends React.Component {

    static defaultProps = {
        estimate: {
            attributes: [],
            project: {}
        },
        onApply: () => {}
    }

    getAttributeHeaders = () => {
        const type = this.props.estimate?.product?.type

        if (type == 'PPA') {
            return (
                <thead>
                    <tr>
                        <th>Term (Yrs)</th>
                        <th>Cost/kWh</th>
                        <th>Annual Riser</th>
                        <th>Fees</th>
                        <th>Payment</th>
                    </tr>
                </thead>
            )
        } 
            return (
            <thead>
                <tr>
                    <th>Term (Yrs)</th>
                    <th>Rate</th>
                    {type === 'PACE PPA' && <th>Annual Riser</th>}
                    {this.optionNeedsCapI() && <th>Capital Interest</th>}
                    <th>Fees</th>
                    <th># of paymts/yr</th>
                    <th>per payem't</th>
                    <th>Annual Paym't</th>
                    {type === 'PACE PPA' && <th>Cost/kWh</th>}
                </tr>
            </thead>
            )
        
    }

    getAttributeRows = () => {
        let rows = [];

        let type = this.props.estimate?.product?.type


        this.props.estimate.attributes
            .sort((a,b) => a.term > b.term ? 1 : -1)
            .forEach(d => {
            let annual_payments = d.schedule.filter(p => p.year === 1).length;
            let annual_cost = d.schedule
                .filter(p => p.year === 1).map(p => p.payment_w_fees)
                .reduce((r,p) => r + p, 0)
            let p1 = d.schedule[0]

            if (type === 'PPA') {
                rows.push(
                    <tr>
                        <td>{d.term}</td>
                        <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(d.cost_per_kwh)}</td>
                        <td>{d.annual_riser}%</td>
                        <td>{formatters.USDCurrency.formatter(p1.fees)}</td>
                        <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(p1.payment_w_fees)}</td>
                    </tr>
                )
            } else {
                rows.push(
                    <tr>
                        <td>{d.term}</td>
                        <td>{d.rate}%</td>
                        {type === 'PACE PPA' && <td>{d.annual_riser}%</td>}
                        {this.optionNeedsCapI() && <td>{formatters.USDCurrency.formatter(d.capitalized_interest)}</td>}
                        <td>{formatters.USDCurrency.formatter(p1.fees)}</td>
                        <td>{annual_payments}</td>
                        <td>{formatters.USDCurrency.formatter(p1.payment_w_fees)}</td>
                        <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(annual_cost)}</td>
                        {type === 'PACE PPA' && <td className="has-text-weight-semibold">{formatters.USDCurrency.formatter(d.cost_per_kwh)}</td>}
                    </tr>
                )
            }
        })

        return rows

    }


    renderNoteTable(notes) {
        notes = notes || []
        notes = sortBy(notes, note => note.title)

        let rows =  notes.map(note => {
            return (
                <tr>
                    <td className="is-size-7 has-text-weight-semibold">
                        {note.title}
                    </td>
                    <td className="has-text-grey is-size-7">
                        {note.note}
                    </td>
                </tr>
            )
        })


        return (
            <div className="table-container">
                <table className="table">
                    <tbody>
                    {rows}
                    </tbody>
                </table>
            </div>
        )
    }

    getTitle() {
        if (this.props.title) {
            return this.props.title
        } if (this.props.showType) {
            return this.props.estimate?.product.type
        } 
            return 'Option ' + this.props.index
        
    }


    optionNeedsCapI = () => {
        return this.props.estimate.attributes.some(d => d.capitalized_interest)
    }


    render () {

        let type = this.props.estimate?.product?.type
        return (
            <div className="card loan-estimate-card mb-6">
                <div className="card-content">
                    <div className="content">
                        <div className="level mb-4 ">
                            <div className="level-left">
                                <div className="level-item">
                                    <div className="title is-size-4 has-text-primary pl-3 pt-3">
                                        {this.getTitle()}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-container">
                            <table className="table is-striped">
                                {this.getAttributeHeaders()}
                                <tbody>
                                {this.getAttributeRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {this.props.estimate?.notes.lenght > 0 }
                    <NoteSection title="Notes about this option" notes={this.props.estimate?.notes} isOpenOnMount/>
                    {!!(this.props.estimate?.program_notes || []).length &&
                        <NoteSection title="Notes about the PACE program"
                                     notes={this.props.estimate?.program_notes}
                                     isOpenOnMount
                        />
                    }
                </div>
                {/* <div style={{height: '600px', width: '100%'}}> */}
                {/* <LineChart /> */}
                {/* </div> */}
            </div>
        )
    }
}